import { getBridge } from "@/utilities/bridge";

export enum HAPTIC_TYPES {
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
  CLICK = "CLICK",
}

const sendMessage = (type: HAPTIC_TYPES) => {
  return () => getBridge().send.haptic({ type });
};

export const triggerHaptic = {
  success: sendMessage(HAPTIC_TYPES.SUCCESS),
  error: sendMessage(HAPTIC_TYPES.ERROR),
  click: sendMessage(HAPTIC_TYPES.CLICK),
};

export type TriggerHaptic = typeof triggerHaptic;
export type TriggerHapticValue = TriggerHaptic[keyof TriggerHaptic];
